"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Card = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _moment = _interopRequireDefault(require("moment"));

require("moment/locale/es");

var _icon = require("../icon");

require("./index.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Node
// Setting Locale
// ShpmtcDesign Components
// Style
_moment.default.locale('en');

var Card = function Card(_ref) {
  var profilePhotoUrl = _ref.profilePhotoUrl,
      profileTitle = _ref.profileTitle,
      profileContent = _ref.profileContent,
      heroImage = _ref.heroImage,
      meta = _ref.meta,
      hoverable = _ref.hoverable,
      style = _ref.style,
      className = _ref.className,
      type = _ref.type,
      checked = _ref.checked,
      borderRidusType = _ref.borderRidusType,
      borderLine = _ref.borderLine,
      borderLineColor = _ref.borderLineColor,
      children = _ref.children,
      onClick = _ref.onClick,
      shadow = _ref.shadow;
  var cardBlock;
  var borderRadiusClass = '';
  var borderLineClass = '';

  switch (borderRidusType) {
    case 'lg':
      borderRadiusClass = 'shpmtc-card--borderRadius-lg';
      break;

    default:
      break;
  }
  /* shadow */


  var shadowClass = '';

  switch (shadow) {
    case 'none':
      shadowClass = 'shpmtc-card--shadow-none';
      break;

    case 'line':
      shadowClass = 'shpmtc-card--shadow-line';
      break;

    case 'shadow':
    default:
      shadowClass = '';
      break;
  }

  switch (borderLine) {
    case 'top':
      borderLineClass = 'card-border-line--top';
      break;

    case 'right':
      borderLineClass = 'card-border-line--right';
      break;

    case 'bottom':
      borderLineClass = 'card-border-line--bottom';
      break;

    case 'left':
    case '':
    default:
      borderLineClass = 'card-border-line--left';
      break;
  } // Addon Elements


  var titleArrow = checked ? null : /*#__PURE__*/_react.default.createElement(_icon.Icon, {
    type: "shpmtcdicon-arrow-right"
  });
  var aheadItem;
  var actionAddonItem;

  if (meta) {
    aheadItem = /*#__PURE__*/_react.default.createElement("div", null, checked ? /*#__PURE__*/_react.default.createElement(_icon.Icon, {
      type: "shpmtcdicon-alert-success",
      style: {
        fontSize: '30px'
      }
    }) : meta.ahead);
    actionAddonItem = meta.actionAddon ? /*#__PURE__*/_react.default.createElement("div", {
      className: "action-addon"
    }, meta.actionAddon) : null;
  }

  var borderLineColorStyle = borderLineColor ? {
    backgroundColor: borderLineColor
  } : null;
  var borderLineElement = borderLine ? /*#__PURE__*/_react.default.createElement("span", {
    className: "card-border-line ".concat(borderLineClass),
    style: borderLineColorStyle
  }) : null; // Date

  var dateDay;
  var dateMonth;

  if (meta) {
    dateDay = meta.date ? (0, _moment.default)(meta.date).format('DD') : null;
    dateMonth = meta.date ? (0, _moment.default)(meta.date).format('MMM') : null;
    console.log(meta.date);
    console.log(dateMonth);
    console.log(dateDay);
  } // Icon


  function renderIcon(icon) {
    var IconElement = /*#__PURE__*/_react.default.cloneElement(icon, {
      className: 'icon-element'
    });

    return IconElement;
  }

  switch (type) {
    case 'Feature':
      cardBlock = /*#__PURE__*/_react.default.createElement("section", {
        className: "\n            shpmtc-card shpmtc-card--feature ".concat(borderRadiusClass, " ").concat(shadowClass, " ").concat(className, "\n          "),
        style: style
      }, heroImage ? /*#__PURE__*/_react.default.createElement("div", {
        className: "hero-image"
      }, heroImage) : null, meta ? /*#__PURE__*/_react.default.createElement("div", {
        className: "feature-container"
      }, meta.date ? /*#__PURE__*/_react.default.createElement("div", {
        className: "date-item"
      }, /*#__PURE__*/_react.default.createElement("b", {
        className: "date-item__day"
      }, dateDay), /*#__PURE__*/_react.default.createElement("p", {
        className: "date-item__month"
      }, dateMonth), /*#__PURE__*/_react.default.createElement("span", {
        className: "border-line"
      })) : null, /*#__PURE__*/_react.default.createElement("div", {
        className: "ahead-item"
      }, aheadItem), /*#__PURE__*/_react.default.createElement("div", {
        className: "content-block"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "content-block__info ".concat(actionAddonItem ? 'has-add-on' : '')
      }, /*#__PURE__*/_react.default.createElement("h3", {
        className: "\n                      title\n                      ".concat(meta.titleLineClamp ? 'line-clamp' : '', "\n                    "),
        style: {
          WebkitLineClamp: meta.titleLineClamp
        }
      }, /*#__PURE__*/_react.default.createElement("span", null, meta.title, meta.titleArrow ? titleArrow : null)), actionAddonItem, /*#__PURE__*/_react.default.createElement("div", {
        className: "content ".concat(meta.contentLineClamp ? 'line-clamp' : ''),
        style: {
          WebkitLineClamp: meta.contentLineClamp
        }
      }, meta.content)))) : null, borderLineElement);
      break;

    case 'Profile':
      cardBlock = /*#__PURE__*/_react.default.createElement("section", {
        className: "\n            shpmtc-card shpmtc-card--profile ".concat(borderRadiusClass, " ").concat(shadowClass, " ").concat(className, "\n          "),
        style: style
      }, /*#__PURE__*/_react.default.createElement("img", {
        className: "photo",
        src: profilePhotoUrl,
        alt: ""
      }), /*#__PURE__*/_react.default.createElement("div", {
        className: "content-block"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "content-block__info"
      }, /*#__PURE__*/_react.default.createElement("h3", {
        className: "title"
      }, profileTitle), /*#__PURE__*/_react.default.createElement("div", {
        className: "content"
      }, profileContent))), borderLineElement);
      break;

    case 'Data':
      cardBlock = /*#__PURE__*/_react.default.createElement("section", {
        className: "\n            shpmtc-card shpmtc-card--data ".concat(borderRadiusClass, " ").concat(shadowClass, " ").concat(className, "\n          "),
        style: style
      }, meta ? /*#__PURE__*/_react.default.createElement("div", {
        className: "container"
      }, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("h6", {
        className: "label"
      }, meta.label ? meta.label : null), /*#__PURE__*/_react.default.createElement("h5", {
        className: "value"
      }, meta.value ? meta.value : null)), /*#__PURE__*/_react.default.createElement("div", {
        className: "icon"
      }, meta.icon ? renderIcon(meta.icon) : null)) : null);
      break;

    default:
      cardBlock = /*#__PURE__*/_react.default.createElement("section", {
        className: "\n            shpmtc-card ".concat(borderRadiusClass, " ").concat(shadowClass, " ").concat(className, "\n          "),
        style: style
      }, children, borderLineElement);
      break;
  }

  return /*#__PURE__*/_react.default.createElement("div", {
    className: "\n        card-equal-height\n        ".concat(hoverable ? 'hoverable' : '', "\n        ").concat(checked ? 'card-checked-status' : '', "\n      "),
    onClick: onClick
  }, cardBlock);
}; // Prop Types


exports.Card = Card;
Card.defaultProps = {
  profilePhotoUrl: '',
  profileTitle: null,
  profileContent: null,
  heroImage: null,
  meta: null,
  hoverable: false,
  style: null,
  className: '',
  type: null,
  checked: null,
  borderRidusType: null,
  borderLine: null,
  borderLineColor: null,
  children: null,
  onClick: null,
  shadow: 'shadow'
};
Card.propTypes = {
  profilePhotoUrl: _propTypes.default.string,
  profileTitle: _propTypes.default.node,
  profileContent: _propTypes.default.node,
  heroImage: _propTypes.default.node,
  meta: _propTypes.default.instanceOf(Object),
  hoverable: _propTypes.default.bool,
  style: _propTypes.default.instanceOf(Object),
  className: _propTypes.default.string,
  type: _propTypes.default.string,
  checked: _propTypes.default.bool,
  borderRidusType: _propTypes.default.string,
  borderLine: _propTypes.default.string,
  borderLineColor: _propTypes.default.string,
  children: _propTypes.default.node,
  onClick: _propTypes.default.func,
  shadow: _propTypes.default.string
};